<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="600px">
      <v-card>
        <v-toolbar elevation="0">
          <v-toolbar-title class="pl-3 text--subtitle">
            <v-icon color="primary" style="padding-bottom: 2px"
              >mdi-security</v-icon
            >
            Remover {{ videos.length }} items do grupo
            <span :title="group.name">{{ group.name }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pl-7 pr-5 py-0">
          <v-container class="pl-0">
            <v-row no-gutters>
              Você realmente deseja excluir os {{ videos.length }} items desse
              grupo? <br />
              Todas as configurações de segurança relacionadas a esse grupo
              serão removidas dos items selecionados.
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-8 pb-6">
          <v-spacer></v-spacer>
          <v-btn
            text
            class="mr-4 px-4"
            :disabled="isFetching"
            @click="handleClose"
          >
            {{ $t('message.close') }}
          </v-btn>
          <v-btn
            min-width="160px"
            color="primary"
            :loading="isFetching"
            :disabled="isFetching"
            @click="handleConfirm"
          >
            <span class="mx-2">
              {{ $t('message.remove') }}
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import drmApi from '@/services/drmApi'

export default {
  name: 'DrmRemoveVideo',
  components: {},
  data: () => ({
    open: false,
    isFetching: false,
    videos: [],
    group: {
      name: 'Adoleta',
    },
  }),
  watch: {},
  mounted() {
    this.$root.$on('openDrmRemoveVideo', (data) => {
      this.group = data.group
      this.videos = data.videos
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('openDrmRemoveVideo')
  },
  methods: {
    async handleConfirm() {
      this.isFetching = true
      let foldersIds = []
      let videosIds = []
      for (let item of this.videos) {
        if (item.name) foldersIds.push(item.id)
        if (item.title) videosIds.push(item.id)
      }
      console.log('foldersIds', foldersIds)
      console.log('videosIds', videosIds)
      try {
        let ret = await drmApi.drmUpdateVideos(this.group.id, {
          videos: {
            action: 'delete',
            video_ids: videosIds,
          },
          folders: {
            action: 'delete',
            folder_ids: foldersIds,
          },
        })
        this.$root.$emit('removeVideoFromDrm', this.videos, this.group.id)
        console.log('ret', ret)
      } catch (e) {
        this.isFetching = false
        console.log('e', e)
      }
      this.handleClose()
      this.isFetching = false
    },
    handleClose() {
      this.open = false
    },
  },
}
</script>

<style>
.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}
</style>
